import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function FailedMethods() {
  const methods = [{
    title: "El 'Time-out' o rincón de pensar",
    desc: 'Solo hace que el niño se sienta solo y resentido, sin aprender qué hizo mal.'
  }, {
    title: 'Las amenazas vacías',
    desc: '"Si no te sientas, no hay iPad por un año" destruyen tu autoridad porque tu hijo sabe que no las cumplirás.'
  }, {
    title: "Intentar 'ignorar' el berrinche",
    desc: 'A veces escala la situación hasta que terminas cediendo por vergüenza, especialmente en público.'
  }, {
    title: 'Libros de crianza americanos',
    desc: 'A veces ignoran nuestra realidad cultural y el temperamento de nuestras familias latinas.'
  }];
  return <section className="py-20 px-4 bg-terracotta text-cream" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <FadeIn data-id="element-56">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-4 text-cream" data-id="element-57">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-center text-terracotta-200 text-xl mb-12 max-w-2xl mx-auto" data-id="element-58">
            No es tu culpa. Te han dado las herramientas equivocadas para el
            trabajo más importante del mundo.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-59">
          {methods.map((method, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-60">
              <div className="bg-terracotta-600/50 p-6 rounded-2xl border border-terracotta-400 flex gap-4 items-start" data-id="element-61">
                <XCircle className="w-8 h-8 text-coral-300 shrink-0 mt-1" data-id="element-62" />
                <div data-id="element-63">
                  <h3 className="text-xl font-bold mb-2 font-heading text-cream-50" data-id="element-64">
                    {method.title}
                  </h3>
                  <p className="text-terracotta-100 leading-relaxed" data-id="element-65">
                    {method.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}